import { render, staticRenderFns } from "./ProfitStructure.vue?vue&type=template&id=5cb14e5a&scoped=true"
import script from "./ProfitStructure.vue?vue&type=script&lang=js"
export * from "./ProfitStructure.vue?vue&type=script&lang=js"
import style0 from "./ProfitStructure.vue?vue&type=style&index=0&id=5cb14e5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb14e5a",
  null
  
)

export default component.exports